import { Text, TextProps } from "../Typography"
import { styled, StyleProps, callCSSFn, CSS } from "../styles"

type Props = Omit<TextProps, `use` | "ref" | `as`>

const SubTitleComponent = ({ tag, ...props }: Props) => <Text use="headline2" {...{ tag: tag || `h2`, ...props }} />

export const makeStyledSubTitle = <T extends unknown>(component: (props: T) => JSX.Element) =>
  styled(component)(
    (props: StyleProps & T): CSS => ({
      lineHeight: 1,
      textTransform: `uppercase`,
      ...callCSSFn(props),
    })
  )

export const SubTitle = makeStyledSubTitle(SubTitleComponent)
